export default "__VITE_ASSET__DYHKuHoQ__"